import { render } from "./Main.vue?vue&type=template&id=4773f3a3&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=4773f3a3&scoped=true&lang=scss"

import exportComponent from "/Users/devgroup/work/hanbyul/hanbyeol/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4773f3a3"]])

export default __exports__